import { ContactActivityFeed } from './ContactActivityFeed';
import { ContactPeopleCard } from './ContactPeopleCard';
import {
  ContactAISummaryCard,
  ContactBalanceCard,
  ContactOpenInvoicesCard,
} from './ContactSummaryCards';

/** Activity tab: balance and contact details on the left, the feed in a narrower column on the right. Columns scroll on their own on wide screens */
export function ContactOverviewV2() {
  return (
    <div className={ `grid grid-cols-1 gap-5 xl:h-full xl:grid-cols-[minmax(0,3fr)_minmax(26.25rem,2fr)]` }>
      <div className={ `flex flex-col gap-3 xl:min-h-0 xl:overflow-auto` }>
        <ContactBalanceCard />
        <ContactPeopleCard />
        <ContactOpenInvoicesCard />
        <ContactAISummaryCard />
      </div>
      <ContactActivityFeed />
    </div>
  );
}
